import {
  Configuration,
  ContentApi,
  AuthorizationApi,
  MemberApi,
  CalendarEventApi,
  ProgrammeGroupApi,
  PersonalDataApi,
  BuildingBlockApi,
  ModuleFormApi,
  IdLogonApi,
  FileApi,
  JobMatchApi,
  DocumentApi,
  AssignmentApi,
  CompanySearchApi,
  OnboardingApi,
  JobSearchApiV2Api,
  MapsApi,
  JobGoalApi,
  NotificationCenterApi
} from '../generated-api'
import type { IFactory } from './IFactory'
import { Capacitor } from '@capacitor/core'

export class FactoryBuilder implements IFactory {
  async getContentApi(): Promise<ContentApi> {
    return new ContentApi(await this.getApiConfiguration())
  }

  async getAuthorizationApi(): Promise<AuthorizationApi> {
    return new AuthorizationApi(await this.getApiConfiguration())
  }

  async getMemberApi(): Promise<MemberApi> {
    return new MemberApi(await this.getApiConfiguration())
  }

  async getCalendarEventApi(): Promise<CalendarEventApi> {
    return new CalendarEventApi(await this.getApiConfiguration())
  }

  async getProgrammeGroupApi(): Promise<ProgrammeGroupApi> {
    return new ProgrammeGroupApi(await this.getApiConfiguration())
  }

  async getPersonalDataApi(): Promise<PersonalDataApi> {
    return new PersonalDataApi(await this.getApiConfiguration())
  }

  async getBuildingblockApi(): Promise<BuildingBlockApi> {
    return new BuildingBlockApi(await this.getApiConfiguration())
  }

  async getModuleFormApi(): Promise<ModuleFormApi> {
    return new ModuleFormApi(await this.getApiConfiguration())
  }

  async getIdLogonApi(): Promise<IdLogonApi> {
    return new IdLogonApi(await this.getApiConfiguration())
  }

  async getFileApi(): Promise<FileApi> {
    return new FileApi(await this.getApiConfiguration())
  }

  async getJobMatchApi(): Promise<JobMatchApi> {
    return new JobMatchApi(await this.getApiConfiguration())
  }

  async getJobGoalApi(): Promise<JobGoalApi> {
    return new JobGoalApi(await this.getApiConfiguration())
  }

  async getDocumentApi(): Promise<DocumentApi> {
    return new DocumentApi(await this.getApiConfiguration())
  }

  async getAssignmentApi(): Promise<AssignmentApi> {
    return new AssignmentApi(await this.getApiConfiguration())
  }

  async getCompanySearchApi(): Promise<CompanySearchApi> {
    return new CompanySearchApi(await this.getApiConfiguration())
  }

  async getOnboardingApi(): Promise<OnboardingApi> {
    return new OnboardingApi(await this.getOnboardingApiConfiguration())
  }

  async getJobSearchApiV2(): Promise<JobSearchApiV2Api> {
    return new JobSearchApiV2Api(await this.getApiConfiguration())
  }

  async getMapsApi(): Promise<MapsApi> {
    return new MapsApi(await this.getApiConfiguration())
  }

  async getNotificationCenterApi(): Promise<NotificationCenterApi> {
    return new NotificationCenterApi(await this.getApiConfiguration())
  }

  private async getApiConfiguration(): Promise<Configuration> {
    let path
    const appLanguageUrl = localStorage.getItem('appLanguageUrl')
    const chosenLanguageUrl = localStorage.getItem('chosenLanguageUrl')

    if (chosenLanguageUrl != undefined && Capacitor.getPlatform().toLocaleLowerCase() !== 'web') {
      path = chosenLanguageUrl
    } else if (appLanguageUrl != undefined) {
      path = appLanguageUrl
    }

    return new Configuration({
      basePath: path,
      credentials: 'include',
      headers: {
        Origin: window.location.hostname,
        'X-Platform': Capacitor.isNativePlatform() === true ? 'NativeApp' : 'WebPortal'
      }
    })
  }

  private async getOnboardingApiConfiguration(): Promise<Configuration> {
    return new Configuration({
      basePath: import.meta.env.VITE_ONBOARDING_API_URL_DK,
      credentials: 'include',
      headers: {
        Origin: window.location.hostname,
        'X-Platform': Capacitor.isNativePlatform() === true ? 'NativeApp' : 'WebPortal'
      }
    })
  }

  async getOnboardingBasePath(): Promise<string> {
    return (await this.getOnboardingApiConfiguration()).basePath || ''
  }
}
